import type {CustomerAccount} from '@src/types/customerAccounts.ts';
import {useGetProjectInfo} from '@api/ims.ts';
import {useAuth} from '@apps-common/auth-react';
import {IMPERSONATION_ROLE_IDS} from '@src/constants/account.ts';
import {DateTime} from 'luxon';

const accountHasImpersonationRights = ({
  roleAssignments,
  validTo,
}: CustomerAccount): boolean => {
  const hasAllowedRole = Object.values<number>(roleAssignments).some(roleId =>
    IMPERSONATION_ROLE_IDS.has(roleId),
  );
  const isAccountValid = DateTime.fromISO(validTo) > DateTime.now();

  return hasAllowedRole && isAccountValid;
};

export const useHasImpersonationRights = ({
  enabled = true,
}: {enabled?: boolean} = {}) => {
  const auth = useAuth();

  const {data: projectInfo, isLoading} = useGetProjectInfo(
    String(auth.user?.claims?.pl_project ?? ''),
    {enabled},
  );

  const hasImpersonationRights = projectInfo
    ? accountHasImpersonationRights(projectInfo.customerAccount)
    : false;

  return {hasImpersonationRights, isLoading};
};
